export type WingmanGenerationProblemKind =
  | "Cancelled"
  | "Conflict"
  | "Forbidden"
  | "Invalid"
  | "NotFound"
  | "RequestTooLarge"
  | "Timeout"
  | "Unauthenticated"
  | "UpstreamError";

export class WingmanGenerationError extends Error {
  readonly kind: WingmanGenerationProblemKind;

  constructor(kind: WingmanGenerationProblemKind, message: string) {
    super(message);
    this.name = "WingmanGenerationError";
    this.kind = kind;
  }
}
